<template lang="pug">
div
  iframe(name="iframe_dummy" style="display:none;")
  //- v-snackbar(v-model="sbar_acl" dark :timeout="2000") IP-ACL 上傳成功
  //- v-snackbar(v-model="sbar_jlist" dark :timeout="2000") 期刊 meta 上傳成功
  //- v-snackbar(v-model="sbar_userpwd" dark :timeout="2000") User-ACL 上傳成功

  v-container#admin
    v-row
      v-col
        v-card
          v-toolbar
            v-toolbar-title 管理後台
            template(v-slot:extension)
              v-tooltip(v-if="$store.state.auth_type=='ip'" bottom)
                template(v-slot:activator="{on, attrs}")
                  v-btn(icon @click='$store.commit("login")' v-bind="attrs" v-on="on")
                    v-icon mdi-login-variant
                span {{$t("login")}}
              v-tooltip(v-else bottom)
                template(v-slot:activator="{on, attrs}")
                  v-btn(icon @click='$store.commit("logout")' v-bind="attrs" v-on="on")
                    v-icon mdi-logout-variant
                span {{$t("logout")}}
              v-tabs(v-if="isadmin" v-model="tab" align-with-title)
                v-tabs-slider
                - let tabs=['ACL', '存取記錄', '期刊meta', '產品說明']
                each i in tabs
                  v-tab=`{{ '${i}' }}`
          v-tabs-items(v-model="tab")
            //- ACL tab
            v-tab-item
              v-navigation-drawer(app right disable-route-watcher max-width="600" v-model="show_sidebar")
                v-container
                  v-row
                    v-col
                      v-file-input(
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        label="上傳IP-ACL"
                        show-size
                        v-model="file_acl"
                        )
                      v-btn.mx-1(@click="on_upload_acl") 上傳
                        v-icon mdi-upload
                  v-row
                    v-col
                      v-file-input(
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        label="上傳User-ACL"
                        show-size
                        v-model="file_userpwd"
                        )
                      v-btn.mx-1(@click="on_upload_userpwd") 上傳
                        v-icon mdi-upload
              v-card
                v-card-text
                  v-form(ref="testip_form" target="iframe_dummy" method="post" action="/udpes/api/dummy" @submit.prevent="test_ip")
                    v-text-field.ma-1(placeholder="check by IP" clearable outlined rounded dense name='udpes-chkip' v-model='ip_')
                      template(slot="append")
                        v-icon(@click="test_ip") mdi-magnify
                  v-form(ref="testuid_form" target="iframe_dummy" method="post" action="/udpes/api/dummy" @submit.prevent="test_uid")
                    v-text-field.ma-1(placeholder="check by UID" clearable outlined rounded dense name='udpes-chkuid' v-model='uid_')
                      template(slot="append")
                        v-icon(@click="test_uid") mdi-magnify
                v-data-table(:headers="chk_headers" :items="chk_items" :items-per-page="-1" show-group-by)
                  template(v-slot:item.date="{ item }")
                    v-chip(:color="date_color(item)" dark) {{ item.date }}
                  template(v-slot:item.uright="{ item }")
                    v-chip(v-if="item.all_urights"
                      :color="date_color(item)" dark) 全部
                    v-chip(v-else v-for="i in item.uright" :key="`uright_${item.uid}_${i}`"
                      :color="date_color(item)" dark) {{ i }}
            //- access log
            v-tab-item
              v-navigation-drawer(app right disable-route-watcher max-width="600" v-model="show_sidebar")
                v-container
                  v-row
                    v-col
                      v-btn.ma-1(@click="export_access_log_url") 下載Log
                        v-icon mdi-download
                      v-btn.ma-1(@click="refresh_recent_log") 近期Log
                        v-icon mdi-sync
              v-card
                //- v-card-text tab::{{tab}}
                v-data-table(:headers="log_headers" :items="log_items" :items-per-page="-1")
            //- Journal Meta / jlist
            v-tab-item
              v-navigation-drawer(app right disable-route-watcher max-width="600" v-model="show_sidebar")
                v-container
                  v-row
                    v-col
                      v-file-input(
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        label="上傳期刊meta"
                        show-size
                        v-model="file_jlist"
                        )
                      v-btn.mx-1(@click="on_upload_jlist") 上傳
                        v-icon mdi-upload
                      v-btn.ma-1(@click="export_artis_statistics_url") 下載文章統計
                        v-icon mdi-download
                  v-row
                    v-col
                      v-divider
                      v-file-input(
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        label="上傳下架清單"
                        show-size
                        v-model="file_removed"
                        )
                      v-btn.mx-1(@click="on_upload_removed") 上傳
                        v-icon mdi-upload
                  v-row
                    v-col
                      v-divider
                      v-btn.ma-1(@click="export_artis_statistics_url") 下載文章統計
                        v-icon mdi-download
                  //- v-row
                  //-   v-col
                  //-     v-btn.mx-1 下載
                  //-       v-icon mdi-download
              v-card
                v-card-text
                  v-form(ref="query_jinfo_form" target="iframe_dummy" method="post" action="/udpes/api/dummy" @submit.prevent="query_jinfo")
                    v-text-field.ma-1(placeholder="查詢uniname" clearable outlined rounded dense name='udpes-query-uniname' v-model='uniname_')
                      template(slot="append")
                        v-icon(@click="query_jinfo") mdi-magnify
                j-info(v-if="jinfo_result" :jj="jinfo_result" no-hover)
                v-card-text(v-if="jinfo_result" v-text="jinfo_result")
            v-tab-item
              v-navigation-drawer(app right disable-route-watcher max-width="600" v-model="show_sidebar")
                v-container
                  v-row
                    v-col
                      v-file-input(
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        label="上傳產品說明"
                        show-size
                        v-model="file_prod_desc"
                        )
                      v-btn.mx-1(@click="on_upload_prod_desc") 上傳
                        v-icon mdi-upload
                
</template>
<script>
const _ = require("lodash")
import { debug } from "@/api/logging"
import { ref, computed } from '@vue/composition-api'
import { all_urights, check_ip, check_uid, get_journal, get_recent_log } from "@/api/prodapi"
import { upload_userpwd, upload_acl, upload_jlist, upload_removed, upload_prod_desc } from "@/api/prodapi"
import {getTokens} from "@/api/token"
import store from '@/store'
import JInfo from "@/components/JInfo"
import {message} from "@/api/states"

export default {
  name: "AdminView",
  components: { JInfo },
  props: {},
  setup() {
    // debug('setup', this) // undefine
    const isadmin = ref(store.state.isadmin)
    const show_sidebar = ref(true)
    store.subscribe((mutation)=>{
      if(mutation.type == 'set_login') {
        isadmin.value = store.state.isadmin
      }
      else if(mutation.type == 'toggle_context_sidebar') {
        show_sidebar.value = !show_sidebar.value
      }
    })

    const testip_form = ref()
    const ip_ = ref("")
    const check_result = ref({})
    const test_ip = () => {
      // debug('test ip', ip_.value, testip_form.value.$el)
      if(testip_form.value && testip_form.value.$el)
        testip_form.value.$el.submit()
      check_ip(ip_.value).then((rr)=>{
        check_result.value = rr
      })
    }

    const testuid_form = ref()
    const uid_ = ref("")
    const test_uid = () => {
      // debug('test uid', uid_.value, testuid_form.value.$el)
      if(testuid_form.value && testuid_form.value.$el)
        testuid_form.value.$el.submit()
      check_uid(uid_.value).then((rr)=>{
        check_result.value = rr
      })
    }

    if(store.state.test) {
      ip_.value = '137.18.78.78'
      uid_.value = 'loc'
      test_uid()
    }

    const chk_headers = [
      {text: "U_NO", value: "uno"},
      {text: "U_ID", value: "uid"},
      {text: "U_NAME", value: "uname"},
      {text: "ValidDate", value: "date"},
      {text: "訂閱", value: "uright"},
      {text: "U_IP_S", value: "ip_start"},
      {text: "U_IP_E", value: "ip_end"},
    ]
    for(let i = 0; i < chk_headers.length; i++) {
      chk_headers[i] = Object.assign({groupable: false, sortable: false}, chk_headers[i])
    }
    const chk_items = computed(()=>{
      if(!check_result.value.rr) return []
      let rr = []
      check_result.value.rr.forEach((i)=>{
        i.all_urights = Boolean(_.isEqual(i.uright.sort(), all_urights))
        rr.push(i)
      })
      return rr
    })
    const date_color = (i) => {
      if(i.date == 'inf') return "blue"
      else if(i.valid) return "green"
      else return "red"
    }

    const export_access_log_url = function() {
      const {access_token} = getTokens()
      const url = '/udpes/api/export/access_log?jwt=' + encodeURIComponent(access_token)
      window.open(url, '_blank')
    }

    const export_artis_statistics_url = function() {
      const {access_token} = getTokens()
      const url = '/udpes/api/export/artis_statistics?jwt=' + encodeURIComponent(access_token)
      window.open(url, '_blank')
    }

    function std_upload(name, msg, upload_api) {
      const file_ = ref(null)
      const on_upload_ = function() {
        if(file_.value == null) {
          return
        }
        const formData = new FormData()
        formData.append(name, file_.value)
        upload_api(formData).then((resp)=>{
          message.value = msg
        })
      }
      return [file_, on_upload_]
    }

    // const [sbar_acl, file_acl, on_upload_acl] = std_upload('acl', upload_acl)
    // const [sbar_userpwd, file_userpwd, on_upload_userpwd] = std_upload('userpwd', upload_userpwd)
    // const [sbar_jlist, file_jlist, on_upload_jlist] = std_upload('jlist', upload_jlist)
    const [file_acl, on_upload_acl] = std_upload('acl', 'IP-ACL 上傳成功', upload_acl)
    const [file_userpwd, on_upload_userpwd] = std_upload('userpwd', 'User-ACL 上傳成功', upload_userpwd)
    const [file_jlist, on_upload_jlist] = std_upload('jlist', '期刊 meta 上傳成功', upload_jlist)
    const [file_removed, on_upload_removed] = std_upload('removed', '下架期刊/文章清單 上傳成功', upload_removed)
    const [file_prod_desc, on_upload_prod_desc] = std_upload('prod_desc', '產品說明 上傳成功', upload_prod_desc)

    const query_jinfo_form = ref()
    const uniname_ = ref("")
    const jinfo_result = ref(null)
    const query_jinfo = () => {
      if(query_jinfo_form.value && query_jinfo_form.value.$el)
        query_jinfo_form.value.$el.submit()
      get_journal(uniname_.value).then((jj)=>{
        jinfo_result.value = jj
      }).catch(()=>{
        jinfo_result.value = null
      })
    }

    const log_headers = ref([
      // {text: "uno", value: "uno"},
      {text: "時間", value: "time"},
      {text: "UID", value: "uid"},
      {text: "IP", value: "ip"},
      {text: "類型", value: "type"},
      {text: "備註", value: "extra"},
    ])
    const log_items = ref([])
    const refresh_recent_log = function() {
      get_recent_log().then((resp)=>{
        // debug('recent_log', resp)
        log_items.value = resp
      })
    }

    if(store.state.test) {
      ip_.value = '137.18.78.78'
      uid_.value = 'loc'
      test_uid()
    }

    return {
      export_artis_statistics_url,

      // sbar_acl, sbar_userpwd, sbar_jlist,
      file_prod_desc, on_upload_prod_desc,
      file_removed, on_upload_removed,
      file_acl, on_upload_acl,
      file_userpwd, on_upload_userpwd,
      file_jlist, on_upload_jlist,

      tab: ref(),
      isadmin,
      show_sidebar,
      testip_form, testuid_form,
      ip_, uid_,
      test_ip, test_uid,
      chk_headers,
      chk_items,
      date_color,

      export_access_log_url,
      refresh_recent_log,
      log_headers,
      log_items,

      query_jinfo_form,
      uniname_,
      jinfo_result,
      query_jinfo,
    }
  },
}
</script>
<style scoped>
#admin {
  max-width: 1200px;
  min-width: 400px;
}
</style>
